import React, { useState } from 'react';
import { Menu, Button } from 'semantic-ui-react';
import { Reorder, AnimatePresence } from 'framer-motion';
import _ from 'lodash';

export const MenuSort = ({ items }) => {

  const [menuItems, setMenuItems] = useState(_.sortBy(items, (item) => item.name));
  const [sortActive, setSortActive] = useState(false);

  // Toggle sorting alphabetically based on the 'name' prop of Menu.Item
  const toggleSort = () => {
    setSortActive((prev) => !prev);

    if (!sortActive) {
      setMenuItems(_.sortBy(menuItems, (item) => item.props.name));
    } else {
      setMenuItems(children);
    }
  };

  return (
    <div>
      <Button toggle active={sortActive} onClick={toggleSort} style={{ marginBottom: '1em' }}>
        {sortActive ? 'Unsort' : 'Sort'}
      </Button>

      <Menu vertical>
        <Reorder.Group axis="y" values={menuItems} onReorder={setMenuItems} style={{ padding: 0 }}>
          <AnimatePresence>
            {_.map(menuItems, (item, index) => (
              <Reorder.Item
                key={item.key || index}
                value={item}
                whileDrag={{ scale: 1.05 }}
                style={{ listStyle: 'none', cursor: 'grab' }}
              >
                {item.name}
              </Reorder.Item>
            ))}
          </AnimatePresence>
        </Reorder.Group>
      </Menu>
    </div>
  );
}
